import { Button, Tooltip, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';

import { getExportFileData, MandateBulkUploadList } from 'api/nach';

import xlsx from 'json-as-xlsx';

import moment from 'moment';

function getFullDate(date: string) {
  if (date != null) {
    return moment(new Date(date)).format('YYYY/MM/DD HH:mm:ss');
  }
  return '';
}

function handleDownload(record: MandateBulkUploadList) {
  const fetchFileFilter = {
    bulkUploadFileId: record.bulkUploadFileId,
  };
  getExportFileData(fetchFileFilter).then((res) => {
    const fileNameFromRecord = record.fileName.replace('.csv', '');
    let settings = {
      fileName: fileNameFromRecord,
      extraLength: 3,
      writeMode: 'writeFile',
      writeOptions: {},
      RTL: false,
    };
    const content = res.data || [];
    const updatedData = content.map((item: any, index) => ({
      ...item,
      // AccountNo: maskAllDigitsExceptLastFour(item.accountNo),
      // requestDate: getFullDate(item.requestDate),
      // mandateStartDate: getFullDate(item.mandateStartDate),
      // mandateEndDate: getFullDate(item.mandateEndDate),
      // aproveMandateCreatedOn: getFullDate(item.aproveMandateCreatedOn),
      LANnumber: item.lanNumber,
      CIF: item.cif,
      MaximumBillingAmount: item.maxBillingAmount,
      MandateAmount: item.mandateAmount,
      Name: item.name,
      ContactNumber: item.contactNo,
      emailId: item.emailId,
      relationshipWithApplicant: item.applicantType,
      NACHtype: item.nachType,
      accountNumber: item.accountNumber,
      IFSCcode: item.ifsc,
      accountName: item.accountName,
      AccountType: item.accountType,
      Status: item.status,
      mandateId: item.mandateId,
      ErrorMessage: item.errorMessage,
      createdDate: getFullDate(item.createdDate),
      isEditable: item.editable === true ? 'Yes' : item.editable === false ? 'No' : '',
      ROWNUM: index + 1,
    }));

    let data = [
      {
        sheet: 'Sheet 1',
        columns: [
          { label: 'ROWNUM', value: 'ROWNUM' },
          { label: 'LAN Number', value: 'LANnumber' },
          { label: 'CIF', value: 'CIF' },
          { label: 'Maximum Billing Amount', value: 'MaximumBillingAmount' },
          { label: 'Mandate Amount', value: 'MandateAmount' },
          { label: 'Name', value: 'Name' },
          { label: 'Contact Number', value: 'ContactNumber' },
          { label: 'Email ID', value: 'emailId' },
          { label: 'Relationship With Applicant', value: 'relationshipWithApplicant' },
          { label: 'NACH Type', value: 'NACHtype' },
          { label: 'IsEditable', value: 'isEditable' },
          { label: 'Account Number', value: 'accountNumber' },
          { label: 'IFSC Code', value: 'IFSCcode' },
          { label: 'Account Name', value: 'accountName' },
          { label: 'Account Type', value: 'AccountType' },
          { label: 'Mandate Request Id', value: 'mandateId' },
          { label: 'Created Date', value: 'createdDate' },
          { label: 'Status', value: 'Status' },
          { label: 'Error Message', value: 'ErrorMessage' },
        ],
        content: updatedData,
      },
    ];

    xlsx(data, settings);
  });
}

const DashboardFilterListColumn: ColumnsType<MandateBulkUploadList> = [
  {
    key: 'bulkUploadFileId',
    title: 'File Id',
    dataIndex: 'bulkUploadFileId',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
    fixed: 'left',
  },
  {
    key: 'fileName',
    title: 'File Name',
    dataIndex: 'fileName',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        <Typography.Text ellipsis={true}>{record}</Typography.Text>
      </Tooltip>
    ),
    fixed: 'left',
  },
  {
    key: 'totalRecord',
    title: 'Total Records',
    dataIndex: 'totalRecord',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'totalSuccessRecord',
    title: 'Success Record',
    dataIndex: 'totalSuccessRecord',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'totalFailedRecord',
    title: 'Failed Record',
    dataIndex: 'totalFailedRecord',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'uploadStatus',
    title: 'Status',
    dataIndex: 'uploadStatus',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'createdDate',
    title: 'Created Date',
    dataIndex: 'createdDate',
    ellipsis: true,
    render: (date: string) => getFullDate(date),
  },

  {
    key: 'createdBy',
    title: 'Created By',
    dataIndex: 'createdBy',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        <Typography.Text ellipsis={true}>{record}</Typography.Text>
      </Tooltip>
    ),
  },
  {
    key: 'sourceApplicationName',
    title: 'Source Application Name',
    dataIndex: 'sourceApplicationName',
    ellipsis: true,
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        <Typography.Text ellipsis={true}>{record}</Typography.Text>
      </Tooltip>
    ),
  },
  {
    key: 'downloadFile',
    title: 'Export',
    dataIndex: 'downloadFile',
    ellipsis: true,

    render: (_text, record) => (
      <Button
        className="ant-btn ant-btn-primary"
        size="small"
        onClick={() => handleDownload(record)}
      >
        EXPORT
      </Button>
    ),
  },
];

export default DashboardFilterListColumn;
